import React from 'react';
import config from '../../config';

const { REACT_APP_CAMPAIGNS_URL } = config;

const RedirectCamapigns = () => {
  React.useEffect(() => {
    window.location.href = REACT_APP_CAMPAIGNS_URL;
  }, []);

  return null;
};

export default RedirectCamapigns;
